<template>
  <div>
    <el-row>
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="20">
        <div class="title">
          <h1>CIA:VR情境化沉浸附件</h1>
        </div>
        <div class="picture">
          <img src="../assets/project19_1.png.webp" />
        </div>
        <div class="abstract">
          当VR用户需要从现实世界中获取物品或观察物品状态时，由于视觉通道被VR头显完全占用，用户需要或脱离VR头显，这将严重破坏沉浸感，打断体验流程。
          <br /><br />
          本研究引入情境化现实感知增强的概念，情境化地、有选择性地增强用户对现实世界中关键元素的感知。因此，设计了一套能够快速注册现实世界中特定物品的VR情境化沉浸附件——CIA。
          <br /><br />
          能够实现用户与现实世界中关键物品的无缝、高效交互，从而弥合虚拟与现实世界的交互鸿沟。
        </div>
      </el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="20"><div class="picture"><img src="../assets/project19_2.png.webp" /></div></el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="20"><div class="picture"><img src="../assets/project19_3.png.webp" /></div></el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>

    <el-row :gutter="40" style="margin-top: 50px">
      <el-col :span="2"><div class="grid-content"></div></el-col>
      <el-col :span="20"><div class="picture"><img src="../assets/project19_4.png.webp" /></div></el-col>
      <el-col :span="2"><div class="grid-content"></div></el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "Project19Zh",
};
</script>

<style scoped>
.picture img {
  width: 100%;
}
.abstract {
  margin-top: 24px;
  font-size: 15px;
  color: #333;
  font-weight: 100;
  text-align: justify;
  line-height: 1.9;
}
.grid-content {
  min-height: 36px;
}
.title {
  margin-top: 100px;
  text-align: center;
}
.title h1 {
  font-size: 30px;
  font-weight: 100;
  letter-spacing: 3px;
  color: #333333;
}
</style>
